// extracted by mini-css-extract-plugin
export var meta = "work-entry-module--meta--1fXIj";
export var article = "work-entry-module--article--3Dy-i";
export var body = "work-entry-module--body--3QOdC";
export var mockupsWrapper = "work-entry-module--mockups-wrapper--3QkPW";
export var mockup = "work-entry-module--mockup--1p703";
export var articleNavigation = "work-entry-module--articleNavigation--miD8C";
export var container = "work-entry-module--container--1rwUU";